import React from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const GoogleAuth = ({ detailsAppointment ,ssno, tietosuoja}) => {
  const { t } = useTranslation(); // Initialize the useTranslation hook
  console.log(detailsAppointment);
  const appointmentDetailsQuery = encodeURIComponent(JSON.stringify(detailsAppointment));
  console.log("appointmentdetails json", appointmentDetailsQuery)
  //stateString = base64UrlEncode('{ "a" : "b" , "c" : 1 }');
 

   
  const handleGoogleSignIn = async () => {
    try {

      const regexSsno = /\b\d{6}[-+A-Za-z0-9]*\b/;
      if (ssno === "") {
        alert(t('kirjoita_sosiaaliturvatunnus'));
        return;
    } else if (!regexSsno.test(ssno)) {
        alert(t('Anna_oikea_sosiaaliturvatunnus'));
        return;
    }
    if (!tietosuoja) {
      alert(t('hyvaksy_tietosuoja'));
      return;
    }

      window.location.href = `https://accounts.google.com/o/oauth2/auth?client_id=140330666394-4ck80tck7hmkk3ructf7iab3rgtmvf31.apps.googleusercontent.com&redirect_uri=https://babeweb.trafore.com:3001/googleauth&scope=email%20profile&response_type=code&state=${appointmentDetailsQuery}`;

    } catch (error) {
      console.error('Error:', error.message);
    }
  };

 
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ display: 'inline-block', marginTop: '10px' }}>
        <button onClick={handleGoogleSignIn} style={{ display: 'flex', alignItems: 'center', backgroundColor: 'white', border: '1px solid #ccc', padding: '10px', borderRadius: '5px', cursor: 'pointer' }}>
          <img src="https://banner2.cleanpng.com/20180728/tju/kisspng-google-logo-business-microsoft-windows-operating-system-5b5cb99e99ca38.3321008115328034866299.jpg" alt="Google Logo" style={{ width: '70px', height: '40px', marginRight: '5px' }} />
          <span style={{ fontWeight: 'bold' }}>Varaa aika Googlella</span>
        </button>
      </div>
    </div>

  );
};

export default GoogleAuth;
